var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styles from "./CohortSkillGroup.module.scss";
import { Icon } from "@eightfold.ai/octuple";
import { IconPathName } from "../../IconPath/mdi";
var SingleProjectSelectionInfo = function () {
    return (_jsxs("div", __assign({ className: styles.targetErrorMessageContainer }, { children: [_jsx(Icon, { classNames: styles.infoIconStyle, path: IconPathName.mdiInfoBg }), _jsx("div", __assign({ className: styles.targetErrorMessage }, { children: "Targets have been removed because the selected data includes assessments with multiple target values. Narrow your Project(s) selection to enable target comparisons." }))] })));
};
export default SingleProjectSelectionInfo;
